import { useMemo } from 'react';
import { useOpts } from '../context';
import useOrgName from './useOrgName';
import { getWriteJobFromToken } from '../utils';
import { useGetLocalizedString } from './useGetLocalizedString';
import { selectIsCompanyConnectJob } from '../state/slices/slice-link-params';
import { useAppSelector } from '../state';
import { checkHackyWorkspace } from '../utils/hacky-workspace-customizations';
var useSuccess = function () {
    var getLocalizedString = useGetLocalizedString();
    var linkTokenPayload = useOpts().linkTokenPayload;
    var accountId = linkTokenPayload.accountId;
    var writeJob = getWriteJobFromToken(linkTokenPayload);
    var orgName = useOrgName();
    var isCompanyConnectJob = useAppSelector(selectIsCompanyConnectJob);
    var workspaceName = linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.workspaceName;
    var isDiscover = checkHackyWorkspace('Discover HELOC', workspaceName) ||
        checkHackyWorkspace('Discover HELOC Theme Testing', workspaceName);
    var title = useMemo(function () {
        if (isDiscover)
            return getLocalizedString('YOUR_DIRECT_DEPOSIT_DISCOVER');
        if (writeJob) {
            if (writeJob === 'bill_switch') {
                return getLocalizedString('BILL_SWITCH_SUCCESS');
            }
            if (writeJob === 'bill_cancellation') {
                return getLocalizedString('BILL_CANCELLATION_SUCCESS');
            }
            return getLocalizedString('YOUR_DIRECT_DEPOSIT');
        }
        if (isCompanyConnectJob)
            return getLocalizedString('YOUR_ORGANIZATION_CONNECTED');
        return accountId
            ? getLocalizedString('YOUR_ACCOUNT_RECONNECTED', [orgName])
            : getLocalizedString('YOUR_ACCOUNT_CONNECTED', [orgName]);
    }, [
        isDiscover,
        writeJob,
        getLocalizedString,
        accountId,
        orgName,
        isCompanyConnectJob,
    ]);
    var subtitle = useMemo(function () {
        if (isDiscover)
            return '';
        return getWriteJobFromToken(linkTokenPayload) === 'direct_deposit_switch'
            ? getLocalizedString('YOUR_CHANGES_SHOULD')
            : getLocalizedString('SUCCESS_SUBTITLE');
    }, [isDiscover, linkTokenPayload, getLocalizedString]);
    return {
        title: title,
        subtitle: subtitle,
    };
};
export default useSuccess;
